import "UI/Widget/Forms/Control/Text";
/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Text
 */
UI.Widget.Forms.Control.Datepicker = Class(UI.Widget.Forms.Control.Text,
    /** @lends UI.Widget.Forms.Control.Datepicker.prototype */
    {
        minDate : "2000-01-01",
        maxDate : moment().year() + 20 + "-12-31",
		createElement: function() {
            this.$element = $("<input type='date'>");

			if (this.disabled) {
				this.$element.prop("disabled", true);
			}
			this.$control.attr('html-min', this.minDate);
			this.$control.attr('html-max', this.maxDate);

        },
        insertElement: function() {
            this.ParentCall();

            var changeMonth = this.$control.attr("change-month") == "yes";
            var changeYear = this.$control.attr("change-year") == "yes";
            var yearRange = this.$control.attr("year-range");

            // this.$element.datepicker({
            //     changeMonth: changeMonth,
            //     changeYear: changeYear,
            //     yearRange: yearRange,
            //     dateFormat: 'dd.mm.yy'
            // });
        },

        removeElement: function() {
            //this.$element.datepicker('destroy');
            
            this.ParentCall();
        },

        listenElement: function() {
            var self = this;
            var altFormat = Util.coalesce(this.$control.attr("alt-format"), "");

            this.$element.on("change", function() {
                if (this.value) {
                    self.setValue(altFormat ? moment(this.value, 'YYYY-MM-DD').format(altFormat) : this.value);
                } else {
                    self.setValue();
                }
            });

            this.$element.on("blur", function () {
                if(this.value){
                    if(moment(this.value).year() < 1000) {
                        var dayAndMonth = moment(this.value).format("MM-DD");
                        var selectedYear = moment(this.value).year();
                        if (selectedYear < moment().year() - 1980) { //последние две цифры текущего года + 20
                            // ввели 5 -> год 2005
                            if (Math.floor(selectedYear / 10) === 0) {
                                this.value = "200" + selectedYear + "-" + dayAndMonth;
                            } else {
                                // ввели 10 -> год 2010
                                this.value = "20" + selectedYear + "-" + dayAndMonth;
                            }
                            self.setValue(altFormat ? moment(this.value, 'YYYY-MM-DD').format(altFormat) : this.value);
                        } else {
                            //ввели 99 -> год 1999
                            if (Math.floor(selectedYear / 100) === 0) {
                                this.value = "19" + selectedYear + "-" + dayAndMonth;
                            } else {
                                //ввели 999 -> год 1999
                                this.value = "1" + selectedYear + "-" + dayAndMonth;
                            }
                            self.setValue(altFormat ? moment(this.value, 'YYYY-MM-DD').format(altFormat) : this.value);
                        }
                    }
                }
            })
            // var enteredDate = "";
            // this.$element.on("keyup", function(event){
            //    if(this.value === ""){
            //        enteredDate += event.originalEvent.key;
            //        if(enteredDate.length == 2){
            //            if(enteredDate == "00"){ //мало ли какой user попадется
            //                this.value = "2000-01-01";
            //            } else {
            //                this.value = "2000-01-" + enteredDate;
            //            }
            //            enteredDate = "";
            //        }
            //    }
            // });
        },

        updateElement: function(value) {
            var altFormat = Util.coalesce(this.$control.attr("alt-format"), "");
            if (value) {
                value = altFormat ? moment(value, altFormat).format('YYYY-MM-DD') : value;
            }
            this.Parent(value);
        }
    }
);
